import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { useTrackProgress } from '../../userProgress';
import { useMostRecentExamAttempt } from '../../exams';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';
import RetakeExamButton from './RetakeExamButton';
import { useFullTrack } from '../../tracks';
import { jsx as _jsx } from "react/jsx-runtime";
const ExamCertificationExpiredScreen = ({
  trackId,
  language
}) => {
  const {
    track,
    trackLoading,
    trackError
  } = useFullTrack(trackId, language);
  const {
    trackProgress,
    trackProgressLoading,
    trackProgressError
  } = useTrackProgress(Number(trackId));
  const award = trackProgress === null || trackProgress === void 0 ? void 0 : trackProgress.award;
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading,
    mostRecentExamAttemptError
  } = useMostRecentExamAttempt(Number(trackId), language);
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    callToAction: /*#__PURE__*/_jsx(RetakeExamButton, {
      language: language,
      trackId: trackId,
      use: "primary"
    }),
    error: trackError || trackProgressError || mostRecentExamAttemptError,
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.isExpiredHeader"
    }),
    illustration: "announcement",
    language: language,
    loading: trackLoading || trackProgressLoading || mostRecentExamAttemptLoading,
    prompt: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.yourPreviousScoreWas",
      options: {
        correctQuestionCount: mostRecentExamAttempt && mostRecentExamAttempt.score,
        totalQuestionCount: track && track.exam.length
      }
    }),
    subheading: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.exams.finished.isExpired",
      options: {
        expiryDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "ll",
          value: (award === null || award === void 0 ? void 0 : award.expiresAt) || 0
        })
      }
    }),
    trackId: trackId
  });
};
export default ExamCertificationExpiredScreen;